module.exports = __webpack_public_path__ + "static/img/Bachelor_010231.ad6d03a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010231.jpg
// module id = 123
// module chunks = 0